export default __webpack_public_path__ + "static/media/picload.be2b8023.MOV";